@if (availableSizes) {
  @for (size of availableSizes; track size; let i = $index) {
    <app-button-menu-item
      (onClick)="onDownload.emit(size)"
      [fullWidth]="true"
      [name]="'download-' + size"
      location="gallery-download-menu-options"
      [class.last]="size === 'original' && i !== 0"
    >
      <strong>{{ size | capitalize }}</strong>
      @if (size === 'original') {
        <span>({{ sizesEstimates[size] | dataUnitsBigInt }})</span>
      }
      @if (size !== 'original') {
        <span>(~{{ sizesEstimates[size] | dataUnitsBigInt }})</span>
      }
    </app-button-menu-item>
  }
  @if (!availableSizes.length) {
    <div class="no-downloads-available">No downloads available</div>
  }
}
